import Swal from 'sweetalert2';

export const state = {
    alert: null
};

export const mutations = {
    SET_ALERT(state, alertInstance) {
        state.alert = alertInstance;
    },
    SHOW_ALERT(state, options) {
        state.alert(options);
    },
    SHOW_TOAST(state, options) {
        state.alert({
            toast: true,
            ...options,
            position: 'bottom',
            reverseButtons: false,
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
        });
    },
    SHOW_LOAD_ALERT(state) {
        state.alert({
            title: 'Aguarde',
            html: 'Isso pode levar alguns segundos.',
            showConfirmButton: false,
            allowOutsideClick: false,
            confirmButtonText: '',
            customClass: {
                confirmButton: 'eg-button-sweetalert eg-loading-btn'
            },
            didOpen: () => {
                Swal.showLoading();
            }
        });
    }
};
export const actions = {
    setAlert({ commit }, sweetalert2) {
        commit('SET_ALERT', sweetalert2);
    },
    showAlert({ commit }, options) {
        commit('SHOW_ALERT', {
            ...options
        });
    },
    showToast({ commit }, options) {
        commit('SHOW_TOAST', {
            ...options
        });
    },
    showLoadAlert({ commit }) {
        commit('SHOW_LOAD_ALERT');
    }
};
